var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_c("pc-header"), _vm._m(0), _vm._m(1), _c("pc-footer")], 1)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrap" }, [
      _c("img", {
        attrs: { src: require("../../../assets/images/news/news-head-bg.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-wrap" }, [
      _c(
        "div",
        { staticClass: "title", staticStyle: { "text-align": "center" } },
        [_vm._v("关于降低银行卡刷卡手续费的通知")]
      ),
      _c(
        "div",
        { staticClass: "time", staticStyle: { "text-align": "center" } },
        [_vm._v(" 时间： 2021-09-29 ")]
      ),
      _c("div", { staticClass: "news_details_container" }, [
        _c("p", [_vm._v("尊敬的各位商户：")]),
        _c("p", { staticStyle: { "text-indent": "2em" } }, [
          _vm._v(
            "为优化营商环境，降低商户的经营成本，积极响应四部委的对降低小微企业和个体工商户支付手续费的要求，以及中国支付清算协会的倡议，我公司决定自2021年9月30日起至2024年9月29日对符合标准的商户施行降低银行卡刷卡手续费的优惠政策，具体如下："
          )
        ]),
        _c("p", { staticStyle: { "text-indent": "2em" } }, [
          _vm._v(
            "我公司对符合条件的小微企业、个体工商户以及其他类型的标准类商户借记卡线下消费交易，施行收单交易手续费费9折、封顶不变；优惠类商户继续维持原来的7.8折优惠，不作调整。"
          )
        ]),
        _c("p", { staticStyle: { "text-indent": "2em" } }, [
          _vm._v("活动期间如有问题请拨打我公司客服热线4006686689。")
        ]),
        _c("p"),
        _c("p", { staticStyle: { "text-align": "right" } }, [
          _vm._v(" 北京海科融通支付服务有限公司")
        ]),
        _c("p", { staticStyle: { "text-align": "right" } }, [
          _vm._v("2021年9月29日")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }